import { useEffect } from 'react';
import { DemeterTableDefinitionType } from '../../../../Generated/Raven-Demeter/api';
import { useApplicationDispatch, useApplicationSelector } from '../../../../Redux/ReduxStore';
import { selectUserCurrentMarket, setUserCurrentMarket } from '../../../../Redux/Slices/UserSlice';
import useMatchedMarket from './useMatchedMarketHook';
import { IRegionCommoditySelection } from './useRegionCommodityNavigationHook';

const useSyncCurrentMarket = (tableDefinitionType: DemeterTableDefinitionType, regionCommoditySelection: IRegionCommoditySelection): void => {
    const dispatch = useApplicationDispatch();
    const currentMarket = useApplicationSelector(selectUserCurrentMarket);
    const matchedMarket = useMatchedMarket(tableDefinitionType, regionCommoditySelection);

    useEffect(() => {
        if (matchedMarket && matchedMarket !== currentMarket) {
            dispatch(setUserCurrentMarket({ userCurrentMarket: matchedMarket }));
        }
    }, [matchedMarket, currentMarket, dispatch]);
};

export default useSyncCurrentMarket;
